import React, { useState, useEffect } from "react"
import {
  Layout,
  Menu,
  Row,
  Col,
  Input,
  Button,
  Drawer,
  Space,
  Dropdown,
} from "antd"
import Cookies from "js-cookie"

import { AboutUsI, BrandsI } from "../../interface"

import rhrLogo from "../../assets/images/RHR-Logo.svg"
import chevronRight from "../../assets/images/ic_chevron_right_24px.svg"
import chevronLeft from "../../assets/images/ic_chevron_left_24px.svg"
import searchIcon from "../../assets/images/ic_search_24px.svg"
import identity from "../../assets/images/ic_perm_identity_24px.svg"
import expandMore from "../../assets/images/ic_expand_more_24px.svg"
import rhrLogoBlue from "../../assets/images/search-page-rhr-logo.png"
import imageFeature from "../../assets/images/Image-feature.png"
import chevronRed from "../../assets/images/ic_chevron_right_24px_red.svg"
import menuIcon from "../../assets/images/ic_nav_menu.svg"
import closeIcon from "../../assets/images/ic_close.svg"
import signInIcon from "../../assets/images/sign_in_icon.svg"
import googleIcon from "../../assets/images/ic_google-translate.svg"
import myProfileIcon from "../../assets/images/ic_my_profile_icon.svg"
import accountSettingsIcon from "../../assets/images/ic_account_settings.svg"
import signOutIcon from "../../assets/images/ic_sign_out.svg"
import dropdownIcon from "../../assets/images/ic_dropdown.svg"
import dropdownOpenIcon from "../../assets/images/ic_dropdown_open.svg"

import { HomeIcon } from "../../utilities/icons/icons"

import "./HeaderStyles.scss"
import GoogleTranslate from "../GoogleTranslate/GoogleTranslate"
import { ColumnDiv } from "../CustomCookieModal/styled"
import CustomModal from "../CustomModal"
import { deleteUserToken, getUserToken } from "../../utilities/check-cookies"

const { Search } = Input

interface Props {
  searchData?: any
  siteTitle?: string
  isBookingHeader?: boolean
  aboutUsData: any
  accountLink?: string
}

const Header: React.FC<Props> = ({
  searchData,
  siteTitle = "",
  isBookingHeader,
  aboutUsData,
  accountLink = ""
}) => {
  const { Header } = Layout
  const { SubMenu } = Menu

  const [active, setActive] = useState<string>("not-active")
  const [activeSearch, setActiveSearch] = useState<string>("not-active")
  const [showResult, setShowResult] = useState<boolean>(false)
  const [search, setSearch] = useState<string>("")
  const [searchResult, setSearchResult] = useState<BrandsI[]>([])
  const [brand, setBrand] = useState<BrandsI[]>([])
  const [aboutData, setAboutData] = useState<AboutUsI[]>([])

  const [visible, setVisible] = useState(false)

  const [fullWidth, setFullwidth] = useState<number>()

  useEffect(() => {
    setFullwidth(global.window.innerWidth)
  })

  useEffect(() => {
    const handleResize = () => {
      setFullwidth(window.innerWidth)

      if (window.innerWidth > 812) {
        setVisible(false)
      }
    }

    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    setSearchResult(searchData)
    setBrand(searchData)
    searchData.sort((a, b) =>
      a.order > b.order ? 1 : b.order > a.order ? -1 : 0
    )
  })

  useEffect(() => {
    setAboutData(aboutUsData)
  }, [])

  if (typeof window !== "undefined") {
    const sticky = document.getElementById("stickyBtn")
    window.onscroll = () => {
      if (window.pageYOffset >= 20) setActive("active")

      if (window.pageYOffset >= window.innerHeight)
        sticky?.classList.add("active")

      if (window.pageYOffset < window.innerHeight)
        sticky?.classList.remove("active")

      if (window.pageYOffset < 20) setActive("not-active")
    }
  }
  const openSearchField = () => {
    if (typeof window !== "undefined") {
      setActiveSearch("active")
      document.body.style.overflow = "hidden"
      if (activeSearch === "active") {
        document.body.style.overflow = "auto"
        return setActiveSearch("not-active")
      }
    }
  }

  const onSearch = val => {
    if (val !== "") {
      setShowResult(true)
      setSearch(val)
      return
    }
    setShowResult(false)
  }

  const showDrawer = () => {
    setVisible(true)
  }

  const onClose = () => {
    setVisible(false)
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const signInUrl = process.env.GATSBY_ACCOUNT_DOMAIN

  const [isVisible, setIsVisible] = useState<boolean>(false)

  const googleTranslateOverlay = (
    <div
      style={{
        background: "white",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
      onClick={e => e.stopPropagation}
    >
      <GoogleTranslate setIsVisible={setIsVisible}></GoogleTranslate>
    </div>
  )

  const userToken = getUserToken()
  const [isAccountOpen, setIsAccountOpen] = useState<boolean>(false)
  const [isOpenSignOut, setIsOpenSignOut] = useState<boolean>(false)
  const signInOptions = (
    <Menu className="login-menu">
      <Menu.Item key={"1"}>
        <a href={`${signInUrl}account`} style={{ color: "#000000" }}>
          <Row>
            <img src={myProfileIcon} alt="My Profile Icon" />
            MY PROFILE
          </Row>
        </a>
      </Menu.Item>
      <Menu.Item key={"2"} onClick={e => e.domEvent.stopPropagation()}>
        <Row
          onClick={e => {
            e.stopPropagation()
            setIsAccountOpen(!isAccountOpen)
          }}
        >
          <img src={accountSettingsIcon} alt="Account Settings Icon" />
          <span>ACCOUNT SETTINGS</span>
          <img
            src={!isAccountOpen ? dropdownIcon : dropdownOpenIcon}
            alt="Exapand More Icon"
          />
        </Row>
        {isAccountOpen && (
          <ColumnDiv>
            <Row style={{ marginTop: "15px", marginLeft: "5px" }}>
              <img src={expandMore} alt="Exapand More Icon" />
              <a
                href={`${signInUrl}home/change-password`}
                style={{ color: "#000000" }}
              >
                CHANGE PASSWORD
              </a>
            </Row>
            {/* <Row style={{ marginTop: "15px", marginLeft: "5px" }}>
              <img src={expandMore} alt="Exapand More Icon" />
              <a href={`${signInUrl}delete`} style={{ color: "#000000" }}>
                DELETE ACCOUNT
              </a>
            </Row> */}
          </ColumnDiv>
        )}
      </Menu.Item>
      <Menu.Item key={"3"} onClick={() => setIsOpenSignOut(true)}>
        <Row>
          <img src={signOutIcon} alt="Sign Out Icon" />
          <span>SIGN OUT</span>
        </Row>
      </Menu.Item>
    </Menu>
  )

  return (
    <>
      <CustomModal
        visible={isOpenSignOut}
        titleMessage={"Are you sure you want to sign out?"}
        message={"Please save all changes before heading out."}
        okText={"SIGN OUT"}
        cancelText={"CANCEL"}
        onOk={() => {
          deleteUserToken()
          setIsOpenSignOut(false)
        }}
        onCancel={() => setIsOpenSignOut(false)}
        isSignOutIcon
        okButtonWidth={"125px"}
        cancelButtonWidth={"125px"}
      />
      <Header
        className={`${active} ${isBookingHeader ? "is-booking-header" : ""}`}
      >
        <Row
          className="rhr-nav-container tarsier-container"
          justify="space-between"
        >
          <Col span={6} className="logo">
            <a href="/">
              <img src={rhrLogo} alt="RHR Logo" />
            </a>
          </Col>
          <Col className="mobile-nav">
            <img
              src={searchIcon}
              alt=""
              onClick={openSearchField}
              style={{ paddingRight: "2rem" }}
            />
            <img src={menuIcon} alt="" onClick={showDrawer} />
          </Col>
          <Drawer
            onClose={onClose}
            visible={visible}
            width={fullWidth}
            closable={false}
          >
            <Row className="nav-drawer" justify="space-between">
              <Col span={6} className="logo">
                <a href="/">
                  <img src={rhrLogo} alt="RHR Logo" />
                </a>
              </Col>

              <Col
                style={{ display: "flex", cursor: "pointer" }}
                onClick={onClose}
              >
                <img src={closeIcon} alt="Close" />
                <h3
                  style={{
                    color: "#fff",
                    marginTop: "12px",
                    marginRight: "1.2rem",
                  }}
                >
                  Close
                </h3>
              </Col>
            </Row>

            <Menu theme="dark" mode="inline" style={{ marginTop: "5rem" }}>
              <SubMenu key="1" title="About Us">
                <Menu.ItemGroup>
                  {aboutData?.map((item, index) => {
                    const pageSlug = item.name.toLowerCase().replace(/ /g, "-")

                    return (
                      item.status === "published" && (
                        <Menu.Item key={`setting:${index + 1}`}>
                          <a href={`/about-us/${pageSlug}-${index}`}>
                            {item.name}
                            <img src={chevronRight} alt="Chevron Right" />
                          </a>
                        </Menu.Item>
                      )
                    )
                  })}
                </Menu.ItemGroup>
              </SubMenu>
              <SubMenu key="2" title="Our Brands" style={{ marginTop: "2rem" }}>
                {brand.filter(res => res.status === "PUBLISHED").length !==
                  0 && (
                  <Menu.ItemGroup>
                    {brand
                      .filter(
                        res => res.status === "PUBLISHED" && res.slug !== ""
                      )
                      .map((res, key) => (
                        <Menu.Item key={`brands:${key}`}>
                          <a href={`/brand/${res.slug}`}>
                            {res.name}
                            <img src={chevronRight} alt="Chevron Right" />
                          </a>
                        </Menu.Item>
                      ))}
                  </Menu.ItemGroup>
                )}
              </SubMenu>
              <Menu.Item key="3" style={{ marginTop: "2rem" }}>
                <a
                  href="https://www.gorewards.com.ph/partners/21fDsuRFQYng9b7Xm8QsYR"
                  target="_blank"
                >
                  Loyalty Program
                </a>
              </Menu.Item>
              <Menu.Item key="4" style={{ marginTop: "2rem" }}>
                <a
                  href="https://www.linkedin.com/in/robinsons-hotels-and-resorts-aa3749192/"
                  target="_blank"
                >
                  Careers
                </a>
              </Menu.Item>
            </Menu>
            <div style={{ display: "flex", flexDirection: "column" }}>
              {userToken ? (
                <Dropdown overlay={signInOptions} trigger={["click"]}>
                  <a onClick={e => e.preventDefault()}>
                    <Space style={{ paddingLeft: "20px", marginTop: "2rem" }}>
                      <img src={identity} alt="Identity Icon" />
                      <img src={expandMore} alt="Exapand More Icon" />
                    </Space>
                  </a>
                </Dropdown>
              ) : (
                <Space style={{ paddingLeft: "20px", gap: "0" }}>
                  <a href={signInUrl}>
                    <img src={identity} alt="Identity Icon" />{" "}
                  </a>
                </Space>
              )} 

              <Dropdown overlay={googleTranslateOverlay} visible={isVisible}>
                <a onClick={e => e.preventDefault()}>
                  <Space>
                    <img
                      src={googleIcon}
                      alt="Identity Icon"
                      onClick={() => setIsVisible(!isVisible)}
                      style={{ paddingLeft: "25px", marginTop: "2rem" }}
                    />
                  </Space>
                </a>
              </Dropdown>
            </div>

            <Row></Row>
          </Drawer>
          <Col span={18} className="nav-menu">
            {!isBookingHeader ? (
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Menu
                  style={{ width: "100%" }}
                  theme="dark"
                  mode="horizontal"
                  defaultSelectedKeys={["0"]}
                >
                  <SubMenu key="1" title="About Us">
                    <Menu.ItemGroup>
                      {aboutData?.map((item, index) => {
                        const pageSlug = item.name
                          .toLowerCase()
                          .replace(/ /g, "-")

                        return (
                          item.status === "published" && (
                            <Menu.Item key={`settings:${index + 1}`}>
                              <a href={`/about-us/${pageSlug}-${index}`}>
                                {item.name}
                                <img src={chevronRight} alt="Chevron Right" />
                              </a>
                            </Menu.Item>
                          )
                        )
                      })}
                    </Menu.ItemGroup>
                  </SubMenu>
                  <SubMenu key="2" title="Our Brands">
                    {brand.filter(res => res.status === "PUBLISHED").length !==
                      0 && (
                      <Menu.ItemGroup>
                        {brand
                          .filter(
                            res => res.status === "PUBLISHED" && res.slug !== ""
                          )
                          .map((res, key) => (
                            <Menu.Item key={`brands:${key}`}>
                              <a href={`/brand/${res.slug}`}>
                                {res.name}
                                <img src={chevronRight} alt="Chevron Right" />
                              </a>
                            </Menu.Item>
                          ))}
                      </Menu.ItemGroup>
                    )}
                  </SubMenu>
                  <Menu.Item key="3">
                    <a
                      href="https://www.gorewards.com.ph/partners/21fDsuRFQYng9b7Xm8QsYR"
                      target="_blank"
                    >
                      Loyalty Program
                    </a>
                  </Menu.Item>
                  <Menu.Item key="4">
                    <a
                      href="https://www.linkedin.com/in/robinsons-hotels-and-resorts-aa3749192/"
                      target="_blank"
                    >
                      Careers
                    </a>
                  </Menu.Item>
                  <Menu.Item
                    key="5"
                    className="search"
                    onClick={openSearchField}
                  >
                    <div id="magnifying-glass"></div> Search
                  </Menu.Item>
                </Menu>
                {userToken ? (
                  <Dropdown overlay={signInOptions} trigger={["click"]}>
                    <a onClick={e => e.preventDefault()}>
                      <Space style={{ paddingLeft: "20px", gap: "0" }}>
                        <img src={identity} alt="Identity Icon" />
                        <img src={expandMore} alt="Exapand More Icon" />
                      </Space>
                    </a>
                  </Dropdown>
                ) : (
                  <a id="account-link" href={accountLink}>
                    <img src={identity} alt="Identity Icon" />{" "}
                  </a>
                )}
                <Dropdown overlay={googleTranslateOverlay} visible={isVisible}>
                  <a onClick={e => e.preventDefault()}>
                    <Space>
                      <img
                        src={googleIcon}
                        alt="Identity Icon"
                        onClick={() => setIsVisible(!isVisible)}
                        style={{ paddingLeft: "20px" }}
                      />
                    </Space>
                  </a>
                </Dropdown>
              </div>
            ) : (
              <div
                style={{
                  height: "100%",
                  color: "#fff",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <a className="return-txt-btn" href="/">
                  <HomeIcon /> <span>Return to homepage</span>
                </a>
              </div>
            )}
          </Col>
        </Row>
      </Header>
      <Layout className={`${activeSearch} search-container`}>
        <Row className="search-wrap">
          <Col span="24" className="text-center search-top">
            <p onClick={openSearchField} className="back-btn">
              <img src={chevronLeft} alt="Chevron Left" />
              Back
            </p>
            <img src={rhrLogo} alt="RHR Logo" />
          </Col>
          <Col span="24" className="form-search">
            <Search
              placeholder="What are you looking for?"
              allowClear
              enterButton={<img src={searchIcon} alt="Search Icon" />}
              size="large"
              onSearch={onSearch}
            />
            <span>Type above and press Enter to search.</span>
          </Col>
        </Row>
        <Row className="search-result">
          <Col
            className="no-search-result"
            style={showResult ? {} : { display: "none" }}
          >
            <p>
              <strong>Searched Results</strong>
            </p>
            <p>
              <span>
                {
                  searchResult.filter(
                    res =>
                      res.name
                        .toLocaleLowerCase()
                        .includes(search.toLocaleLowerCase().trim()) &&
                      res.status.toLowerCase() === "published"
                  ).length
                }
              </span>{" "}
              results were found for <span>“{search.trim()}”</span>
            </p>
          </Col>
          <Col
            span={24}
            className="search-default-view"
            style={showResult ? { display: "none" } : {}}
          >
            <article className="text-center">
              <img src={rhrLogoBlue} alt="RHR Logo Navy Blue" />
              <span>Type above and press Enter to search.</span>
            </article>
          </Col>
          <Col
            span={24}
            className="search-results-view"
            style={showResult ? {} : { display: "none" }}
          >
            <Row className="search-list">
              {searchResult
                .filter(
                  res =>
                    res.name
                      .toLocaleLowerCase()
                      .includes(search.toLocaleLowerCase().trim()) &&
                    res.status.toLowerCase() === "published"
                )
                .map((res, key) => (
                  <Col key={key} xs={24} xl={8} md={15} className="search-card">
                    <div className="search-card-wrap">
                      <div className="search-card-img">
                        <img
                          src={imageFeature}
                          alt="Image Right"
                          className="img-responsive"
                        />
                      </div>
                      <article className="search-card-details">
                        <p>
                          <strong>{res.name}</strong>
                        </p>
                        {res.short_description}
                        <a
                          href={res.redirect_link}
                          target="_blank"
                          className="know-more"
                        >
                          Know More <img src={chevronRed} alt="Arrow Red" />
                        </a>
                      </article>
                    </div>
                  </Col>
                ))}
            </Row>
          </Col>
        </Row>
      </Layout>
    </>
  )
}

export default Header
